import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const EditSuggestedCustomerPersonaPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "EditSuggestedCustomerPersonaPopup" */ './Container'),
  'popup'
);
